import { Card, CardContent, Typography } from '@mui/material'

export default function TraceCard({ label, value, disabled = false }) {
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 2,
        border: '2px solid #E5E7EB',
        backgroundColor: disabled ? '#F9FAFB' : '#FFFFFF',
        height: 70,
        width: '100%'
      }}
    >
      <CardContent
        className={disabled ? 'trace-card-disabled' : ''}
        sx={{
          p: 2,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center'
        }}
      >
        <Typography
          sx={{
            fontSize: 12,
            color: '#6B7280',
            fontWeight: 600,
            letterSpacing: 0.3,
            mt: 1
          }}
        >
          {label}
        </Typography>

        <Typography
          sx={{
            fontSize: 17,
            fontWeight: 800,
            color: disabled ? '#9CA3AF' : '#111827',
            mt: 0.5,
            wordBreak: 'break-word'
          }}
        >
          {value || '—'}
        </Typography>
      </CardContent>
    </Card>
  )
}

